import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { AppShell } from '@/components/AppShell/AppShell';
import { withSearch } from '@/lib/nav';
import styles from './ThankYou.module.css';

export function ThankYou() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <AppShell>
      <main className={styles.wrap}>
        <div className={styles.card}>
          <i
            className={`ph-fill ph-check-circle ${styles.icon}`}
            aria-hidden="true"
          />
          <h1 className={styles.title}>All done — thanks!</h1>
          <p className={styles.lead}>
            Your files are uploaded to TRO. You can re-enter the project to
            upload additional takes at any time.
          </p>
          <div className={styles.actions}>
            <Button variant="ghost" onClick={() => navigate(withSearch(`/${id}`, location.search))}>
              <i className="ph-bold ph-arrow-left" /> Back to Project
            </Button>
          </div>
        </div>
      </main>
    </AppShell>
  );
}
